import { scrollToId } from './home-ui';

export default function HomeFooter({ data }) {
    if (!data) return null;
    const { brand = '', tagline, columns = [], legal, disclaimer } = data;

    const onLink = (href) => (e) => {
        if (href && href.startsWith('#')) { e.preventDefault(); scrollToId(href.slice(1)); }
    };

    return (
        <footer className="bg-navy-deep text-white">
            <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-10 px-6 py-16 md:grid-cols-4">
                <div className="md:col-span-1">
                    <div className="font-display text-xl font-bold">{brand}</div>
                    {tagline && <p className="mt-3 max-w-xs text-sm text-white/60">{tagline}</p>}
                </div>
                {columns.map((col) => (
                    <div key={col.title}>
                        <div className="font-display text-sm font-bold uppercase tracking-wide text-white/80">{col.title}</div>
                        <ul className="mt-4 space-y-2">
                            {(col.links || []).map((l) => (
                                <li key={l.label}>
                                    <a href={l.href} onClick={onLink(l.href)} className="text-sm text-white/60 hover:text-brand">{l.label}</a>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
            <div className="border-t border-white/10">
                <div className="mx-auto flex max-w-[1200px] flex-col gap-1 px-6 py-5 text-xs text-white/50 sm:flex-row sm:items-center sm:justify-between">
                    <span>{legal}</span>
                    <span>{disclaimer}</span>
                </div>
            </div>
        </footer>
    );
}
